import Vue from 'vue'

// 全局事件总线
export const EventBus = new Vue()

// 事件名称常量
export const EVENTS = {
  SHOW_CREATE_PROJECT: 'show-create-project',
  HIDE_CREATE_PROJECT: 'hide-create-project',
  SHOW_CREDITS_DIALOG: 'show-credits-dialog',
  SHOW_COMMUNITY_DIALOG: 'show-community-dialog',
  SHOW_PROFILE_DIALOG: 'show-profile-dialog',
  SHOW_MESSAGE_CENTER: 'show-message-center'
}

// 便捷方法：显示创建项目弹窗
export function showCreateProjectDialog() {
  EventBus.$emit(EVENTS.SHOW_CREATE_PROJECT)
}

// 便捷方法：隐藏创建项目弹窗
export function hideCreateProjectDialog() {
  EventBus.$emit(EVENTS.HIDE_CREATE_PROJECT)
}
